<template>
  <div class="speech row m-0">
    <div class="col-12 col-lg-8">
      <div class="h-100">
        <p class="intro-title text-lg" v-if="$route.name === 'ai_assistant_follow'">跟讀練習</p>
        <p class="intro-title text-lg" v-if="step === 1 && $route.name === 'ai_assistant_correction'">AI批改結果</p>
          <p class="intro-title text-lg" v-if="$route.name === 'ai_assistant_follow' && step === 0"><img src="@/assets/image/ai/quote.png" alt="">請輸入文字，以進行跟讀練習</p>
          <p class="intro-title text-lg" v-if="$route.name === 'ai_assistant_follow' && step === 1"><img src="@/assets/image/ai/quote.png" alt="">請點擊「全文播放」聆聽全文音檔，或點選右側麥克風進行逐句跟讀練習</p>
        <div v-if="step === 0 && $route.name === 'ai_assistant_follow'">

          <textarea v-model="textVal" contenteditable="true" spellcheck="true" name="textarea" id="textarea" cols="30" rows="15" class="notebook bg-white w-100 rounded overflow-scroll overflow-x-hidden ai_border_03" placeholder="請作答 ..."></textarea>
          <p class="text-center mb-3 text-sm">共 <span class="">{{ textLength }}</span> 字元</p>
          <div class="d-flex flex-wrap justify-content-center">
            <a @click="StartFollow()" class="btn-submit m-2 d-inline-block" :class="{ 'bg-secondary': textLength < 1 }">START</a>
          </div>
        </div>

        <div v-if="step === 0 && $route.name === 'ai_assistant_correction'">
          <h5 class="intro-title text-xl" v-if="aiType === 'speech'">英文演講稿</h5>
          <h5 class="intro-title text-xl" v-if="aiType === 'letter'">商用書信</h5>
          <ImageOCRPopup :visible.sync="show" v-on:submitText="submitText" />
          <p class="intro-title text-lg"><img src="@/assets/image/ai/quote.png" alt="">請輸入文字或點擊下方上傳圖片按鈕，將圖片轉為文字</p>
          <textarea v-model="textVal" contenteditable="true" spellcheck="true" name="textarea" id="textarea" cols="30" rows="15" class="notebook bg-white w-100 rounded overflow-scroll overflow-x-hidden ai_border_03" placeholder="請作答 ..."></textarea>
          <p class="text-center mb-3 text-sm">共 <span class="">{{ textLength }}</span> 字元</p>
          <div class="d-flex flex-wrap justify-content-center">
            <a @click="show = true" class="btn-deny m-2 d-inline-block">上傳圖片</a>
            <!-- <a @click="textVal = null" class="btn-clear d-inline-block m-2 cursor-pointer p-2">清空</a> -->
            <a @click="StartGrading()" class="btn-submit m-2 d-inline-block" :class="{ 'bg-secondary': textLength < 1 }">開始批改</a>
          </div>
        </div>

        <form v-if="step === 0 && aiType === 'speech' && $route.name === 'ai_assistantMain'">
          <h5 class="intro-title text-xl" v-if="aiType === 'speech'">英文演講稿</h5>
          <p class="intro-title text-lg"><img src="@/assets/image/ai/quote.png" alt="">演講資訊</p>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group row mx-0">
                <label for="topic" class="col-form-label mr-2 text-lg font-semibold form-label">主題</label>
                <div class="flex-1" :class="{ 'inValidError': isShowErr && !topic }">
                  <input type="text" class="form-control" id="topic" placeholder="e.g. 新產品介紹" v-model="topic">
                  <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !topic">*此欄必須填寫</span>
                </div>
              </div>
              <div class="form-group row mx-0">
                <label for="people" class="col-form-label mr-2 text-lg font-semibold form-label">對象</label>
                <div class="flex-1" :class="{ 'inValidError': isShowErr && !audience }">
                  <input type="text" class="form-control" id="people" placeholder="e.g. 各大企業客戶" v-model="audience">
                  <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !audience">*此欄必須填寫</span>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group row mx-0">
                <label for="topic" class="col-form-label mr-2 text-lg font-semibold form-label">類型</label>
                <div class="flex-1">
                  <div class="w-100" :class="{ 'inValidError': isShowErr && !genre }">
                    <select :class="{ 'inValidError': isShowErr && !genre }" class="form-select w-100 py-2" aria-label="Default select" id="type" style="border: 1px solid #ced4da;" v-model="genre">
                      <option selected :value="null">請選擇</option>
                      <option value="Meeting Presentation">會議簡報 Meeting Presentation</option>
                      <option value="Project Proposal">企劃提案 Project Proposal</option>
                      <option value="Motivational Speech">激勵致詞 Motivational Speech</option>
                      <option value="Knowledge Sharing">知識分享 Knowledge Sharing</option>
                      <option value="Elevator Pitch">電梯簡報 Elevator Pitch</option>
                      <option value="Product Demonstratio">產品示範 Product Demonstratio</option>
                    </select>
                  </div>
                  <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !genre">*此欄必須填寫</span>
                </div>
              </div>
              <div class="form-group row mx-0">
                <label for="people" class="col-form-label mr-2 text-lg font-semibold form-label">場合</label>
                <div class="flex-1">
                  <select :class="{ 'inValidError': isShowErr && !setting }" class="form-select w-100 py-2" aria-label="Default select" id="setting" style="border: 1px solid #ced4da;" v-model="setting">
                    <option selected :value="null">請選擇</option>
                    <option value="Internal Project Meeting">內部專案會議 Internal Project Meeting</option>
                    <option value="External Business Communication">對外商務溝通 External Business Communication</option>
                    <option value="Results Presentation and Knowledge Sharing">成果發表與知識分享 Results Presentation and Knowledge Sharing</option>
                    <option value="Motivation and Other Information Delivery">激勵與其他資訊傳達 Motivation and Other Information Delivery</option>
                  </select>
                  <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !setting">*此欄必須填寫</span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group" :class="{ 'inValidError': isShowErr && !content }">
            <label for="detail" class="text-lg font-semibold form-label">內容簡述 (字數上限100字)</label>
            <textarea v-model="content" class="form-control" id="detail" rows="8"
            placeholder="e.g. 本次演講將發表最新上市的 AI 產品,針對產品優勢與特性說明,以協助各企業提升營運效率與創新競爭力。" ></textarea>
            <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !content">*此欄必須填寫</span>
          </div>
          <div class="w-100 d-flex justify-content-center">
            <!-- <a class="btn-clear mx-2 d-inline-block" @click="reset">清空</a> -->
            <a class="btn-submit mx-2 d-inline-block py-2" @click="createLetter()">START</a>
          </div>
        </form>

        <form v-if="step === 0 && aiType === 'letter' && $route.name === 'ai_assistantMain'">
        <h5 class="intro-title text-xl" v-if="aiType === 'letter'">商用書信</h5>
          <div class="row">
            <div class="col-12 col-lg-6">
              <p class="intro-title text-lg"><img src="@/assets/image/ai/quote.png" alt="">寄件人資訊</p>
              <div class="form-group row mx-0">
                <label for="SenderName" class="col-form-label mr-2 text-lg font-semibold form-label">寄件人姓名</label>
                <div class="flex-1" :class="{ 'inValidError': isShowErr && !s_name }">
                  <input type="text" class="form-control" id="SenderName" placeholder="e.g. Emily" v-model="s_name">
                  <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !s_name">*此欄必須填寫</span>
                </div>
              </div>
              <!-- <div class="form-group row mx-0">
                <label for="SenderAppellation" class="col-form-label mr-2 text-lg font-semibold form-label">寄件人稱謂</label>
                <div class="flex-1">
                  <input type="text" class="form-control" id="SenderAppellation" placeholder="EX: Apple CEO">
                </div>
              </div> -->
              <div class="form-group row mx-0">
                <label for="SenderDepartment" class="col-form-label mr-2 text-lg font-semibold form-label">寄件人公司</label>
                <div class="flex-1" :class="{ 'inValidError': isShowErr && !s_itentity }">
                  <input type="text" class="form-control" id="SenderDepartment" placeholder="e.g. ABC公司" v-model="s_itentity">
                  <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !s_itentity">*此欄必須填寫</span>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <p class="intro-title text-lg"><img src="@/assets/image/ai/quote.png" alt="">收件人資訊</p>
              <div class="form-group row mx-0">
                <label for="addresseeName" class="col-form-label mr-2 text-lg font-semibold form-label">收件人姓名</label>
                <div class="flex-1" :class="{ 'inValidError': isShowErr && !r_name }">
                  <input type="text" class="form-control" id="addresseeName" placeholder="e.g. David" v-model="r_name">
                  <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !r_name">*此欄必須填寫</span>
                </div>
              </div>
              <!-- <div class="form-group row mx-0">
                <label for="addresseeAppellation" class="col-form-label mr-2 text-lg font-semibold form-label">收件人稱謂</label>
                <div class="flex-1">
                  <input type="text" class="form-control" id="addresseeAppellation" placeholder="EX: Apple CEO">
                </div>
              </div> -->
              <div class="form-group row mx-0">
                <label for="addresseeDepartment" class="col-form-label mr-2 text-lg font-semibold form-label">收件人公司</label>
                <div class="flex-1" :class="{ 'inValidError': isShowErr && !r_itentity }">
                  <input type="text" class="form-control" id="addresseeDepartment" placeholder="e.g. XYZ公司" v-model="r_itentity">
                  <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !r_itentity">*此欄必須填寫</span>
                </div>
              </div>
            </div>

            <div class="col-12">
              <p class="intro-title text-lg"><img src="@/assets/image/ai/quote.png" alt="">信件資訊</p>
                <div class="form-group" :class="{ 'inValidError': isShowErr && !purpose }">
                  <label for="emailTitle" class="text-lg font-semibold form-label">信件主旨</label>
                  <input type="text" class="form-control" id="emailTitle" placeholder="e.g. 專案合作細節洽談" v-model="purpose">
                  <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !purpose">*此欄必須填寫</span>
                </div>
                <div class="form-group" :class="{ 'inValidError': isShowErr && !content }">
                  <label for="emailTitle" class="text-lg font-semibold form-label">內容簡述 (字數上限100字)</label>
                  <textarea class="form-control" id="emailTitle" rows="8" placeholder="e.g. 關於本次新產品專案合作細節，針對上市時程、合作細節、分潤模式，希望能約貴公司下週進行當面會談，以利雙方業務推展。" v-model="content"></textarea>
                  <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !content">*此欄必須填寫</span>
                </div>
            </div>
            <div class="col-12 d-flex justify-content-center">
              <!-- <a class="btn-clear mx-2 d-inline-block" @click="reset">清空</a> -->
              <a class="btn-submit mx-2 d-inline-block py-2" @click="createLetter()">START</a>
            </div>
          </div>
        </form>

        <GenerateResults v-if="step === 1" :resultsEn="resultsEn" :resultsZh="resultsZh" :ttsUrlMale="ttsUrlMale" :ttsUrlFemale="ttsUrlFemale" v-on:resultsZh="emitResultsZh" v-on:failPopUp="failPopUp" v-on:getZnPopUp="getZnPopUp" :aiType="aiType" :correction="correction" :textValSplit="textValSplit" :textVal="textVal"/>
      </div>
    </div>
    <div class="col-12 col-lg-4 mt-3 mt-lg-0">
      <Rule v-if="step === 0 || $route.name === 'ai_assistant_correction' || $route.name === 'ai_assistant_follow' || $route.params.generateType === 'correct'" :aiType="aiType" />
      <InputData v-if="(step === 1 || step === 2) && $route.name !== 'ai_assistant_correction' && $route.name !== 'ai_assistant_follow' && $route.params.generateType !== 'correct'" v-on:editData="editData" :aiType="aiType" :topic="topic" :content="content" :audience="audience" :r_name="r_name" :r_itentity="r_itentity" :s_name="s_name" :s_itentity="s_itentity" :purpose="purpose" :genre="genre" :setting="setting" />
    </div>
  </div>
</template>

<script>
import api from '@/store/api'
import Rule from '@/components/AiHelper/rule.vue'
import InputData from '@/components/AiHelper/speech/inputData.vue'
import GenerateResults from '@/components/AiHelper/speech/generateResults.vue'
import allJs from '@/components/AiHelper/all.js'
import { mapGetters } from 'vuex'
import ImageOCRPopup from '@/components/AiHelper/speech/ImageOCRPopup.vue'
export default {
  name: 'Speech',
  components: {
    Rule,
    InputData,
    GenerateResults,
    ImageOCRPopup
  },
  data () {
    return {
      step: 0,
      isShowErr: false,
      show: false,
      textVal: '',
      // textVal: 'I’ve been interested in space travel since childhood, when I read a book about the men who first traveled to the moon. They described seeing our blue planet from space for the first time, and after seeing the pictures they took, I knew I wanted to experience what they did firsthand. I also wanted to be inside a spacecraft and learn what zero gravity felt like. As a child, I watched many science fiction films such as Star Wars, and even though I knew what happened in these movies wasn’t real, they made me hungry to explore the universe. For all of these reasons and more, I believe my dream job is to be an astronaut. Since space is still our final frontier, and people might soon be going to Mars, it is the perfect time for me to give it my best shot. To do so, I’ve been reading about the training astronauts require, and learning about the sacrifices they have to make. Being an astronaut is a dangerous job, but I believe I have the courage and intelligence to take it on. After all, going into space has been my lifelong dream, and to be paid to do it would be the icing on the cake.',

      content: null,

      topic: null,
      audience: null,
      genre: null,
      setting: null,

      r_name: null,
      r_itentity: null,
      s_name: null,
      s_itentity: null,
      purpose: null,

      resultsEn: null,
      resultsZh: null,
      ttsUrlMale: null,
      ttsUrlFemale: null,

      correction: null
    }
  },
  computed: {
    ...mapGetters([
      'remainPoints',
      'getFollowData'
    ]),
    aiType () {
      return this.$route.params.aiType
    },
    textLength () {
      return this.textVal ? this.textVal.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, '').split(' ').filter(word => word.length > 0).length : 0
    },

    textValSplit () {
      return this.textVal ? this.textVal.split(/(?<=[.?!])\s+/) : []
    }
  },
  mixins: [
    allJs
  ],
  mounted () {
    if (this.$route.name === 'viewGenerate') {
      this.viewRecord()
    }

    this.$store.dispatch('setAccent', 'en-EN')

    if (this.$route.name === 'ai_assistant_follow' && this.$route.query.follow) {
        const myName1 = () => {
          return new Promise(async(resolve) => {
          let followData = JSON.parse(localStorage.getItem("followData")) || null
          this.textVal = followData ? followData : null

            if (this.textVal) {
              resolve('isBegin')
            }

          })
        }
        Promise.race([myName1()])
        .then(() => {
          this.$store.dispatch("clearFollowData")
        })
    }
    if (!this.$route.query.follow) {
      this.$store.dispatch("clearFollowData")
    }
  },
  methods: {
    viewRecord () {
      let self = this
      let path = `/ai/requests/${self.$route.params.promptId}`
      self.$store.dispatch('isLoading', true)
      api.get(path)
      .then(async(res) => {
        self.$store.dispatch('isLoading', false)

        self.step = 1

        if (this.$route.params.generateType === 'generate') {
          this.resultsEn = res.data.result.content

          this.r_itentity = res.data.userdata.r_itentity
          this.s_itentity = res.data.userdata.s_itentity
          this.s_name = res.data.userdata.s_name
          this.r_name = res.data.userdata.r_name
          this.audience = res.data.userdata.audience
          this.topic = res.data.userdata.s_topic
          this.purpose = res.data.userdata.letter_purpose
          this.content = res.data.userdata.speech_content || res.data.userdata.letter_content || ''

          const [femaleUrl, maleUrl] = await Promise.all([
            this.getTTSUrl('female', res.data.result.content),
            this.getTTSUrl('male', res.data.result.content)
          ])

          this.ttsUrlFemale = femaleUrl
          this.ttsUrlMale = maleUrl
        } else {
          this.resultsEn = res.data.userdata.content
          this.correction = res.data.result.content
        }
      })
      .catch(() => {
        self.$store.dispatch('isLoading', false)
      })
    },
    emitResultsZh (emitResultsZh) {
      let self = this
      self.resultsZh = emitResultsZh
    },

    editData () {
      let self = this
      self.step = 0
      self.resultsZh = null
    },

    createLetter () {
      let self = this
      if ((self.aiType === 'speech' && self.topic && self.content && self.audience && self.genre && self.setting) || (self.aiType === 'letter' && self.r_name && self.r_itentity && self.s_name && self.s_itentity && self.purpose && self.content)) {
        if (self.remainPoints < 20) {
          self.failPopUp('點數不足')
        } else {
          self.postData()
        }
      } else {
        self.isShowErr = true
      }
    },

    postData () {
      let self = this
      let jsonData
      if (self.aiType === 'letter') {
        jsonData = {
          r_name: self.r_name,
          r_itentity: self.r_itentity,

          s_name: self.s_name,
          s_itentity: self.s_itentity,

          letter_purpose: self.purpose,
          letter_content: self.content
        }
      } else {
        jsonData = {
          // type: self.type,
          s_topic: self.topic,
          speech_content: self.content,
          audience: self.audience,
          genre: self.genre,
          setting: self.setting
        }
      }

      let path = `/ai/generate/${self.aiType}`

        api.post(path, JSON.stringify(jsonData))
        .then(async(res) => {
          if (res.data && res.data.result) {
            self.resultsEn = res.data.result

            self.step = 1

          // eslint-disable-next-line
            self.ttsUrlFemale = await self.getTTSUrl('female', res.data.result)
            self.ttsUrlMale = await self.getTTSUrl('male', res.data.result)

            self.$store.dispatch('getRemainPoints')
          } else {
            // self.failPopUp()
          }
        })
        .catch((error) => {
          self.failPopUp(error.response.data.msg)
        })
    },

    failPopUp (text) {
      let self = this
      let defaultTitle = text ?  `<h3>${text}</h3><p>請洽客服人員加購點數</p>` : `<h3>生成失敗</h3><p>糟糕！發生了一點小失誤，請再給我一次機會！</p>`
      self.$swal.fire({
        html: defaultTitle,
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: `確認`,
        customClass: {
          container: '',
          popup: 'p-0',
          header: 'swal-header',
          closeButton: '',
          htmlContainer: 'htmlContainer my-3',
          actions: 'mb-4 mt-5',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
        }
      })
    },

    getZnPopUp () {
      let self = this
      self.$swal.fire({
        html: `<h3>翻譯完成</h3>`,
        showCloseButton: false,
        focusConfirm: false,
        confirmButtonText: `確認`,
        customClass: {
          container: '',
          popup: 'p-0',
          header: 'swal-header-success',
          closeButton: '',
          htmlContainer: 'htmlContainer my-3',
          actions: 'mb-4 mt-5',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
        }
      })
    },

    submitText (payload) {
      this.textVal += payload
    },

    async StartGrading() {
      if (!this.textVal) return;

      let path = `/ai/generate/correct/${this.aiType}`;

      try {
        if (this.aiType === 'speech') {
          let calPoints = this.remainPoints - 20;
          const result = await this.$swal({
            html: `
              <h3>確定開始批改英文演講稿？</h3>
              <p>目前總點數 <span style="color: #F30000;">${this.remainPoints}</span> 點</p>
              <p>需扣除 20 點</p>
              <p>扣除後點數 <span style="color: #F30000;">${calPoints}</span> 點</p>
            `,
            showDenyButton: true,
            focusConfirm: false,
            confirmButtonText: `確認`,
            denyButtonText: `返回修改`,
            title: 'Notice',
            customClass: {
              title: 'text-white',
              container: '',
              popup: 'p-0',
              header: 'swal-header-notice justify-content-center align-items-center',
              closeButton: '',
              htmlContainer: 'htmlContainer my-3',
              actions: 'mb-4 mt-5 d-flex',
              confirmButton: 'btn-submit order-2',
              denyButton: 'denyButton-ai order_1',
            },
          });
          if (!result.isConfirmed) return;
        }

        // 呼叫 API 批改
        const res = await api.post(path, { content: this.textVal });

        this.step = 1;
        this.resultsEn = this.textVal;
        this.correction = res.data.result;

        // 更新剩餘點數
        await this.$store.dispatch('getRemainPoints');

      } catch (error) {
        this.failPopUp(error.response?.data?.msg || '系統錯誤，請稍後再試');
      }
    },

    async StartFollow () {
      if (!this.textVal || this.textValSplit.length < 1) return

      this.resultsEn = this.textVal

      this.$store.dispatch('isLoading', true)

      this.ttsUrlFemale = await this.getTTSUrl('female', this.textVal)
      this.ttsUrlMale = await this.getTTSUrl('male', this.textVal)

      this.$store.dispatch('isLoading', false)
      this.$store.dispatch('getRemainPoints')
      this.step = 1
    }
  }
}
</script>
<style lang="scss" scoped>
  a {
    &:hover {
      text-decoration: none !important;
    }
  }
  .border-1 {
    border: 1px solid #000000;
  }
  .speech {
    @media (min-width: 640px) {
      padding: 1.5rem !important;
    }
    @media (min-width: 640px) {
      padding: 1.5rem !important;
    }
  }
  form {
    label {
      white-space: nowrap;
    }
    .form-label {
      @media (max-width: 1024px) {
        font-size: 1rem;
      }
    }
  }
  .intro-title {
    color: #F30000;
    font-weight: 700;
    margin-bottom: 0.75rem;
    @media (max-width: 1024px) {
      font-size: 1.125rem;
    }
  }
  .menu_speech_outer {
    border-bottom: 1px solid #0E103E;
    .menu_speech {
      border: 1px solid #0E103E;
      border-top-left-radius: 2px;
      border-top-right-radius: 2px;
    }
    .menu_speech_active {
      border: 1px solid #0E103E;
      background-color: #0E103E;
      color: white;
      border-top-left-radius: 2px;
      border-top-right-radius: 2px;
    }
  }
  .notebook {
    width: 100%;
    min-height: 300px;
    padding: 8px;
    font-size: 16px;
    line-height: 28px; /* 讓文字對齊線條 */
    border: 1px solid #000000;
    background: repeating-linear-gradient(
      white 0px,
      white 27px,
      #ddd 27px,
      #ddd 28px
    );
    font-family: Arial, sans-serif
}
</style>
